import { QueryKeys } from './queryKeys'
import { getFirebase } from '../../firebaseApp'
import { AppStatus } from '@/redux'
import { passwordReset } from './views'
import { I18N } from '@/app'

export const reauthenticate = async (password: string) => {
  const firebase = await getFirebase()

  const profile = QueryKeys.me.getData()

  if (!profile) return

  return firebase.auth().signInWithEmailAndPassword(profile.email, password)
}

export const toggleRememberMe = async (rememberMe: boolean) => {
  const firebase = await getFirebase()
  const persistance = rememberMe ? firebase.auth.Auth.Persistence.SESSION : firebase.auth.Auth.Persistence.NONE
  firebase.auth().setPersistence(persistance)
}

export const requestPasswordReset = async (email: string) => {
  await AppStatus.set('loading')

  try {
    await passwordReset(email)

    setTimeout(() => {
      AppStatus.set('done')
    }, 2000)
  } catch (e) {
    await AppStatus.set('idle')
    console.error('Password reset', e, 'Auth')
    alert('There was an error during password reset')
  }
}

export const warnEmailInUse = () => {
  alert(I18N.t('emailInUseMsg'))
}

export function isLoggedIn() {
  const me = QueryKeys.me.getData()

  return !!me?.id
}

export function getProfile() {
  const me = QueryKeys.me.getData()

  return me
}
